import React from 'react';

export function PageHeader({
  kicker,
  title,
  subtitle,
}: {
  kicker: string;
  title: string;
  subtitle: string;
}) {
  return (
    <div className="pageHeader">
      <div className="kicker">{kicker}</div>
      <h1 className="h1">{title}</h1>
      <p className="sub">{subtitle}</p>
    </div>
  );
}

